import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all vehicle document
export const fetchVehicleDocument = createAsyncThunk(
  "vehicle_document/fetchAll",
  async ({ page = 1, status = "", establishment_id = "", document_number = "",type ="",
    is_auto_renewal = "",
    has_expire_date = "" }, { rejectWithValue }) => {
    try {
      const normalize = (val) => {
        if (val === "true" || val === true) return 1;
        if (val === "false" || val === false) return 0;
        return "";
      };
      const response = await axios.get(`${BASE_URL}/vehicle-documents?page=${page}&status=${status}&establishment_id=${establishment_id}&type=${type}&document_number=${document_number}&is_auto_renewal=${normalize(is_auto_renewal)}&has_expire_date=${normalize(has_expire_date)}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);

// add vehicle documents
export const addVehicleDocument = createAsyncThunk(
  "vehicle_document/add",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/vehicle-documents`, userData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// add vehicle documents comments
export const addVehicleDocumentComments = createAsyncThunk(
  "vehicle_document/comments",
  async ({ comment, id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/vehicle-documents/${id}/comments`, comment, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// get vehicle documents record
export const vehicleDocumentRecord = createAsyncThunk(
  "vehicle_document/vehicleDocumentRecord",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/vehicle-documents/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue({ message });
    }
  }
);
// Fetch all vehicle documents once (for filters)
export const fetchAllVehicleDocument = createAsyncThunk(
  "vehicle_document/fetchAllFull",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/vehicle-documents`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load all data";
      return rejectWithValue(message);
    }
  }
);
const VehicleDocumentSlice = createSlice({
  name: "vehicle_document",
  initialState: {
    vehicle_document: [],
    all_vehicle_document: [],
    record: null,
    isLoading: false,
    error: null,
    success: null,
    successComment: null,
    errorComment: null,
    successAdd: null,
    errorAdd: null,
    successDelete: null,
    errorDelete: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
      state.successAdd = null;
      state.errorAdd = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVehicleDocument.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchVehicleDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.vehicle_document = action.payload.data.data;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchVehicleDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(fetchAllVehicleDocument.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllVehicleDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.all_vehicle_document = action.payload.data.data;
      })
      .addCase(fetchAllVehicleDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load all vehicle documents";
      })
      .addCase(addVehicleDocument.pending, (state) => {
        state.isLoading = true;
        state.errorAdd = null;
      })
      .addCase(addVehicleDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successAdd = action.payload.message;
      })
      .addCase(addVehicleDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.errorAdd = action.payload || "Failed to add data";
      })
      .addCase(addVehicleDocumentComments.pending, (state) => {
        state.isLoading = true;
        state.errorComment = null;
      })
      .addCase(addVehicleDocumentComments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successComment = action.payload.message;
      })
      .addCase(addVehicleDocumentComments.rejected, (state, action) => {
        state.isLoading = false;
        state.errorComment = action.payload || "Failed to add data";
      })
      .addCase(vehicleDocumentRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(vehicleDocumentRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(vehicleDocumentRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      });
  },
});

export const { clearState } = VehicleDocumentSlice.actions;
export default VehicleDocumentSlice.reducer;